import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';

const TextInput = (props) => (
  <input {...props} className={classNames(styles.input, props.className)} />
);

export default TextInput;
